/**
 * Created by mac on 8/03/17.
 */

const FloorView = cc.Node.extend({
    ctor: function (field) {
        this._super();

        this.setCascadeOpacityEnabled(true);

        this.onTouchBeganListener = function () {};
        this.onTouchMovedListener = function () {};
        this.onTouchEndedListener = function () {};

        field.iterateFloor((row, col) => {
            this.addBackground(col, row);
        });

        field.iterateTiles((tile) => {
            this.addTile(tile);

            if (tile.constructor === TransporterTile) {
                tile.onSetImage();
                tile.onAnimate();
            }
        });

        field.onGetFloorBackgroundView = this.createListener((x, y) => this.getChildByTag(x * Field.SIZE + y));

        field.on("addTile", this.addTile.bind(this), this);

        this.createBorders(field);
    },

    addBackground: function (x, y) {
        const image = [bundles.game.frames.tile_background_1, bundles.game.frames.tile_background_2][(x + y) % 2];
        const background = cleverapps.UI.createScale9Sprite(image, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        background.setPosition(BaseCellView.alignInTheGrid(x, y));
        this.addChild(background, -1, x * Field.SIZE + y);
    },

    addTile: function (tile) {
        const ViewClass = tile.getViewClass();
        const view = cleverapps.pool.hasObject(ViewClass) ? cleverapps.pool.getFromPool(ViewClass, tile) : new ViewClass(tile);
        view.beforeShowUpAnimation();
        this.addChild(view);
    },

    createBorders: function (filed) {
        const area = [];

        filed.iterateFloor((row, col) => {
            area.push({ x: col, y: row });
        });

        BorderRenderer.place(
            area,
            (borders, cell) => {
                borders.forEach((border) => {
                    const resource = bundles.game.frames[`border_${border.name}`];
                    if (!resource) {
                        return;
                    }

                    const image = new cc.Sprite(resource);
                    image.setLocalZOrder(1);

                    const cellSize = cleverapps.styles.BaseCellView.CELL_SIZE_PX;
                    const horDir = Number(border.name.includes("right")) - Number(border.name.includes("left"));
                    const vertDir = Number(border.name.includes("up")) - Number(border.name.includes("down"));

                    let dx = horDir * (cellSize / 2 + image.width / 2);
                    const dy = vertDir * (cellSize / 2 + image.height / 2);

                    if (border.name.includes("inner")) {
                        dx = horDir * (cellSize / 2 - image.width / 2);
                        image.setLocalZOrder(2);
                    }

                    image.setAnchorPoint(0.5, 0.5);
                    const pos = BaseCellView.alignInTheGrid(cell.x, cell.y);
                    image.setPosition(pos.x + dx, pos.y + dy);

                    this.addChild(image);
                });
            }
        );
    }
});
